export default __webpack_public_path__ + "static/media/Shot_10.0000.c7bac1c4.png";